import { Link, Outlet } from "react-router-dom";
import Navbarmenu from "../function-components/Navbarmenu";
import { useEffect } from "react";
import { fetchCourses } from "../function-components/Redux/BundleSkillsSlice";
import { useDispatch } from "react-redux";

function Home() {

  const dispatch= useDispatch();

  useEffect(()=>{
    dispatch(fetchCourses);
  },[]);

  const navArr=[
    // {name:"Approve Nominations", path:"approve-nominations"},
    {name:"Recommended Trainings", path:"recommended-trainings"},
    {name:"TH", path:"th"}
  ]
  return (
    <div>
      <Navbarmenu items={navArr}/>
      {/* <div className="banner">
        <img
          src={process.env.PUBLIC_URL + "/images/Home/home-banner.png"}
          alt="banner"
          className="home-banner"
        />
        <h1 className="banner-content">Bundle Skills</h1>
      </div> */}
      <Outlet />
    </div>
  );
}

export default Home;
